<template>
  <div>
    <a-modal
      :title="audit ? '合同审批' : '合同申请详情'"
      class="gufiiguy"
      :visible="is_show"
      width="60%"
      @cancel="is_show = false"
      :maskClosable="false"
    >
      <template slot="footer" v-if="!audit">
        <a-button key="submit" type="primary" @click="is_show = false"> 确定 </a-button>
      </template>
      <template slot="footer" v-if="audit">
        <a-button key="back" @click="is_show = false"> 取消 </a-button>
        <a-button type="danger" @click="reject(3)"> 驳回 </a-button>
        <a-button key="submit" type="primary" @click="reject(1)"> 转交 </a-button>
        <a-button key="submit" type="primary" @click="reject(2)"> 通过 </a-button>
      </template>
      <div ref="sadsada">
        <a-form-model :model="info" :label-col="labelCol" :wrapper-col="wrapperCol">
          <div class="title">
            <span>基本信息</span>
          </div>
          <div class="content" ref="directrecordwp">
            <a-row>
              <a-col :span="24">
                <a-form-model-item
                  label="审批标题"
                  class="model_span_form"
                  :label-col="{ span: 3 }"
                  :wrapper-col="{ span: 21 }"
                >
                  <span>{{ info.title }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-model-item
                  label="抄 送 人 "
                  class="model_span_form"
                  :label-col="{ span: 3 }"
                  :wrapper-col="{ span: 21 }"
                >
                  <span>{{ info.ccName }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-model-item
                  label="审批编号"
                  class="model_span_form"
                  :label-col="{ span: 3 }"
                  :wrapper-col="{ span: 21 }"
                >
                  <span>{{ info.applyCode }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="8">
                <a-form-model-item label="所属公司" class="model_span_form">
                  <span>{{ info.companyName }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item label="所属部门" class="model_span_form">
                  <span>{{ info.deptName }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item label="跟进人" class="model_span_form">
                  <span>{{ info.followerName }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="8">
                <a-form-model-item label="跟进人部门" class="model_span_form">
                  <span>{{ info.followerDeptName }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
          </div>
          <div class="title">
            <span>合同信息</span>
          </div>
          <div class="content">
            <a-row>
              <a-col :span="8">
                <a-form-model-item label="标题" class="model_span_form">
                  <span>{{ info.title }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item label="合同编号" class="model_span_form">
                  <span>{{ info.contractCode }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item label="合同名称" class="model_span_form">
                  <span>{{ info.contractName }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="8">
                <a-form-model-item label="客户名称" class="model_span_form">
                  <span>{{ info.customerName }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item label="合同日期" class="model_span_form">
                  <span>{{ info.contractDate }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item label="项目名称" class="model_span_form">
                  <span>{{ info.projectName }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="8">
                <a-form-model-item label="项目编号" class="model_span_form">
                  <span>{{ info.projectCode }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item label="到期日期" class="model_span_form">
                  <span>{{ info.expiryDate }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item label="合同金额" class="model_span_form">
                  <span>{{ info.contractAmount }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="8">
                <a-form-model-item label="剩余回款金额" class="model_span_form">
                  <span>{{ info.remainingMoney }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item label="客户联系人" class="model_span_form">
                  <span>{{ info.customerContact }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item label="联系方式" class="model_span_form">
                  <span>{{ info.contactInformation }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="8" v-if="audit">
                <a-form-model-item label="审批意见" style="margin-top: 25px">
                  <a-textarea placeholder="请输入" v-model="comment" :auto-size="{ minRows: 2, maxRows: 6 }" />
                </a-form-model-item>
              </a-col>
              <a-col :span="8" v-if="record.comment != undefined">
                <a-form-model-item label="审批意见" style="margin-top: 25px">
                  {{ record.comment }}
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-model-item label="附件" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                  <div
                    class="view_path"
                    @click="previewFile(item)"
                    v-for="(item, index) in info.sysAttachmentsFile"
                    :key="index"
                  >
                    {{ item.name }}
                  </div>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-model-item label="上传图片" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                  <div
                    class="view_path_img"
                    v-for="(item, index) in info.sysAttachmentsImg"
                    :key="index"
                    style="display: flex; justify-content: space-between"
                  >
                    <div class="view_path_img_margin"></div>
                    <div class="view_path_img_center">
                      <img :src="item.imgUrl" @click="show_img(index, info.sysAttachmentsImg)" />
                    </div>
                  </div>
                 
                </a-form-model-item>
              </a-col>
            </a-row>
          </div>
           <div class="title" v-if="!audit && recordNumber == 1">
              <span>审批记录</span>
            </div>
            <div class="content" v-if="!audit  && recordNumber == 1">
              <auditModel ref="auditModel"></auditModel>
            </div>
        </a-form-model>
      </div>
    </a-modal>
    <preview ref="preview" />
    <transferModal ref="transferModal" @sure="handleSure" />
  </div>
</template>
<script>
import auditModel from './audit.vue'
import { download_file_java } from '@/utils/request'
import { resolveBlob} from '@/utils/index'
import { axios } from '@/utils/request'
import { downloadPreviewFile } from '../../../utils/downloadPreviewFile'
import { previewFileLists} from '@/utils/preview.js'
import { contract_apply_get } from '@/api/financial'
import { act_task_audit } from '@/api/activiti'
import preview from '@/components/module/prview'
import transferModal from '@/views/activiti/modules/TransferModal.vue'
import Watermark from '../../../utils/watermark'
export default {
  props: {
    audit: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    preview,
    transferModal,
    auditModel
  },

  data() {
    return {
      recordNumber: 0,
      is_show: false,
      info: {},
      labelCol: {
        span: 9,
      },
      wrapperCol: {
        span: 15,
      },
      record: null,
      comment: '',
    }
  },
  activated() {},
  watch: {},
  created() {},
  // mounted() {},
  mounted() {},
  methods: {
    handleSure() {
      this.is_show = false
      this.$emit('ok')
    },
    show_img(idx, imgs) {
      var row = {
        index: idx,
        imgs: imgs,
      }
      this.$refs.preview.show(row)
    },
    //预览文件
async previewFile(file) {
let path = '/' + file.url.split('/')[0] + '/'
let fileName = file.url.substring(file.url.indexOf('/') + 1)
var res = await download_file_java(file.types, path, fileName)
 var file_s_n = file.name.split('.')
 let type = file_s_n[file_s_n.length - 1]
 resolveBlob(res, this.get_file_type[type]) //新窗口打开，借用浏览器去打印
 },
    
//     //预览文件
//     previewFile(file) {
//      let path = '/' + file.url.split('/')[0] + '/'
//      let fileName = file.url.substring(file.url.indexOf("/")+1)
//      axios({
//      url: `/file/file/download?bucketName=${file.types}&path=${path}&fileName=${fileName}`,
//     method: 'post',
//     responseType: 'blob', // 必须要写
//    }).then((res)=>{
//     resolveBlob({
//     data:res,
//     headers:{
//     'content-disposition': `attachment;filename=${fileName}`
//      }
//     })
//     // window.open(file.preUrl)
// })
    // },
    show(record, type = null) {
      this.recordNumber = record.recordNumber
      this.record = record
      console.log(this.record)
      contract_apply_get(record.businessKey).then((res) => {
        if (res.code != 200) {
          this.$message.error(res.msg)
          return
        }
        this.info = res.data
        console.log(res.data, 'res.data=====================')
        console.log(this.info.sysAttachmentsImg, 'this.info.sysAttachmentsImg=====================')
      previewFileLists( this.info.sysAttachmentsImg).then(res=>{
        this.info.sysAttachmentsImg = res
         })
        this.is_show = true
		this.$nextTick(()=>{
			Watermark.set('安联云管家' , this.$refs.sadsada)
       if(!this.audit && this.recordNumber == 1) {
                 this.$refs.auditModel.show(record)
               }
		})
      })
    },
    //驳回
    reject(result_) {
      if (result_ == 1) {
        this.$refs.transferModal.show({
          record: this.record,
        })
      } else {
        act_task_audit({
          taskId: this.record.id,
          procDefKey: this.record.processDefKey,
          procInstId: this.record.procInstId,
          procName: this.record.processName,
          applyer: this.record.applyer,
          result: result_,
          businessKey: this.record.businessKey,
          comment: this.comment,
        }).then((res) => {
          if (res.code != 200) {
            this.$message.error(res.msg)
            return
          }
          this.$message.success('审批成功')
          this.$emit('ok')
          this.is_show = false
        })
      }
    },
    succeed() {},
  },
}
</script>
<style>
.view_path {
  width: 100%;
  float: left;
  cursor: pointer;
  color: #00a2fd;
}
/* .content {
  padding-left: 10px !important;
}
.ant-form-item-label {
  text-align: left;
} */
</style>
